import {
  SUMMARY_DATA_REQUEST,
  SUMMARY_DATA_LOADING,
  SUMMARY_DATA_SUCCESS,
  CALLSPAGE_QUICKFILTER_DATA_REQUEST,
  CALLSPAGE_QUICKFILTER_DATA_SUCCESS,
  SET_ALL_FILTERS,
  CALLS_SUMMARY_DETAILS_CANCEL,
  CALLS_CALLTYPE_DETAILS_CANCEL,
  CALLS_CALLMONTH_DETAILS_CANCEL,
  CALLS_GEO_TIN_COUNT_DATA_REQUEST,
  CALLS_GEO_TIN_COUNT_DATA_SUCCESS,
  CALLS_GEO_TIN_COUNT_DATA_LOADING,
} from '../actionTypes';
import {
  CALLTYPE_DATA_REQUEST,
  CALLTYPE_DATA_SUCCESS,
  CALLTYPE_DATA_ERROR,
  CALLTYPE_DATA_LOADING,
} from '../actionTypes';
import {
  CALLMONTH_DATA_LOADING,
  CALLMONTH_DATA_SUCCESS,
  CALLMONTH_DATA_REQUEST,
  CALLS_PAGE_POLLING_STARTED,
  CALLS_PAGE_POLLING_COMPLETED,
  CALLS_PAGE_POLLING_FAILED,
  CALLS_PAGE_POLLING_RESET,
} from '../actionTypes';

// ---------CALL SUMMARY DATA -----------------
export const fetchSummaryData = (payload: any, geoCriteria?: any) => ({
  type: SUMMARY_DATA_REQUEST,
  payload,
  geoCriteria,
});


export const callsSummaryDetailsCancel = () => ({
  type: CALLS_SUMMARY_DETAILS_CANCEL,
});

export const callsCallTypeDataCancel = () => ({
  type: CALLS_CALLTYPE_DETAILS_CANCEL,
});

export const callsCallMonthDataCancel = () => ({
  type: CALLS_CALLMONTH_DETAILS_CANCEL,
});

export const getQuickFilterDataRequest = (payload: any) => ({
  type: CALLSPAGE_QUICKFILTER_DATA_REQUEST,
  payload,
});

export const getQuickFilterDataSuccess = (payload: any) => ({
  type: CALLSPAGE_QUICKFILTER_DATA_SUCCESS,
  payload,
});

export const summaryDataLoading = (payload: any) => ({
  type: SUMMARY_DATA_LOADING,
  payload,
});

export const fetchSummaryDataSuccess = (payload: any) => ({
  type: SUMMARY_DATA_SUCCESS,
  payload,
});
/* -------------------------------------------------
 ------------------ CALL TYPE DATA -------------------- */
export const fetchCallTypeData = (payload: any, geoCriteria?: any) => ({
  type: CALLTYPE_DATA_REQUEST,
  payload,
  geoCriteria,
});

export const fetchCallTypeDataSuccess = (payload: any) => ({
  type: CALLTYPE_DATA_SUCCESS,
  payload,
});

export const fetchCallTypeDataError = (payload: any) => ({
  type: CALLTYPE_DATA_ERROR,
  payload,
});

export const callTypeDataLoading = (payload: any) => ({
  type: CALLTYPE_DATA_LOADING,
  payload,
});
/* -------------------------------------------------------
-------------------- CALL MONTH DATA ---------------------*/

export const callMonthDataLoading = (payload: any) => ({
  type: CALLMONTH_DATA_LOADING,
  payload,
});

export const fetchCallMonthDataSuccess = (payload: any) => ({
  type: CALLMONTH_DATA_SUCCESS,
  payload,
});

export const fetchCallMonthData = (payload: any, geoCriteria?: any) => ({
  type: CALLMONTH_DATA_REQUEST,
  payload,
  geoCriteria,
});

export const fetchCallsGeoTinCountData = (payload: any) => ({
  type: CALLS_GEO_TIN_COUNT_DATA_REQUEST,
  payload,
});

export const fetchCallsGeoTinCountDataSuccess = (payload: any) => ({
  type: CALLS_GEO_TIN_COUNT_DATA_SUCCESS,
  payload,
});

export const fetchCallsGeoTinCountDataLoading = (payload: any) => ({
  type: CALLS_GEO_TIN_COUNT_DATA_LOADING,
  payload,
});

// Call Summary Page Polling Track Actions

// Prior Auth Polling Status Actions
export const callsPagePollingStarted = () => ({
  type: CALLS_PAGE_POLLING_STARTED,
});

export const callsPagePollingCompleted = () => ({
  type: CALLS_PAGE_POLLING_COMPLETED,
});

export const callsPagePollingFailed = (error: any) => ({
  type: CALLS_PAGE_POLLING_FAILED,
  payload: error,
});

export const callsPagePollingReset = () => ({
  type: CALLS_PAGE_POLLING_RESET,
});

// Consolidated action to set all filters at once (prevents multiple re-renders)
export const setAllFilters = (payload: {
  timePeriod?: any;
  lineOfBusiness?: any;
  taxId?: any[];
  contractId?: any[];
  region?: any;
  state?: any[];
  market?: any[];
  activeChipTins?: any[] | null; // For chip click filtering (null = all TINs, array = specific TINs)
}) => ({
  type: SET_ALL_FILTERS,
  payload,
});
